import React from "react";
import CommunityLayout from "../../components/Community/CommunityLayout";

const MyRoomsPage = () => {
  return (
    <CommunityLayout>
      <h1>My Rooms</h1>
      <p>View and manage your rooms here.</p>
    </CommunityLayout>
  );
};

export default MyRoomsPage;
